var map = {
	"./en/welcome.json": [
		18110,
		8110
	],
	"./fr/welcome.json": [
		39797,
		9797
	],
	"./nl/welcome.json": [
		79659,
		9659
	],
	"./zh/welcome.json": [
		71347,
		1347
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 35215;
module.exports = webpackAsyncContext;